var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStripe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.996512 4.99209C0 6.94785 0 9.50809 0 14.6286V17.3714C0 22.4919 0 25.0521 0.996512 27.0079C1.87307 28.7283 3.27175 30.1269 4.99209 31.0035C6.94785 32 9.50809 32 14.6286 32H17.3714C22.4919 32 25.0521 32 27.0079 31.0035C28.7283 30.1269 30.1269 28.7283 31.0035 27.0079C32 25.0521 32 22.4919 32 17.3714V14.6286C32 9.50809 32 6.94785 31.0035 4.99209C30.1269 3.27175 28.7283 1.87307 27.0079 0.996512C25.0521 0 22.4919 0 17.3714 0H14.6286C9.50809 0 6.94785 0 4.99209 0.996512C3.27175 1.87307 1.87307 3.27175 0.996512 4.99209Z",
    fill: "url(#paint0_linear_2001_21339)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.303112 7.1766C0 8.89921 0 11.1849 0 14.6285V17.3714C0 22.4919 0 25.0521 0.996512 27.0079C1.87307 28.7282 3.27175 30.1269 4.99209 31.0034C6.94785 32 9.50809 32 14.6286 32H17.3714C22.4919 32 25.0521 32 27.0079 31.0034C28.7283 30.1269 30.1269 28.7282 31.0035 27.0079C32 25.0521 32 22.4919 32 17.3714V14.6285C32 9.50804 32 6.9478 31.0035 4.99204C30.1574 3.33155 28.825 1.97074 27.1863 1.08984L0.303112 7.1766Z",
    fill: "url(#paint1_linear_2001_21339)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6689 24.9761C31.5219 25.7484 31.3098 26.4067 31.0034 27.0079C30.1269 28.7283 28.7282 30.1269 27.0079 31.0035C25.1106 31.9702 22.6445 31.9991 17.8242 32H16.0669V28.3849L31.6689 24.9761Z",
    fill: "url(#paint2_linear_2001_21339)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3716 0H14.6288C13.6326 0 12.7333 0 11.9165 0.00733792V4.53774L27.1835 1.08829C27.1254 1.05709 27.0669 1.0265 27.0081 0.996512C25.9223 0.443294 24.6503 0.197197 22.8573 0.0877224C21.4206 0 19.6494 0 17.3716 0Z",
    fill: "url(#paint3_linear_2001_21339)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32 17.5695C31.9999 21.0045 31.9938 23.2687 31.6689 24.976L26.2427 26.1616V18.0752L32 16.7363V17.5695Z",
    fill: "url(#paint4_linear_2001_21339)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7898 13.0034C14.7898 12.2689 15.3903 11.9864 16.3849 11.9864C17.8111 11.9864 19.6126 12.4196 21.0388 13.1917V8.76598C19.4812 8.14449 17.9424 7.89966 16.3849 7.89966C12.5754 7.89966 10.042 9.89596 10.042 13.2294C10.042 18.4273 17.173 17.5987 17.173 19.8398C17.173 20.7061 16.4224 20.9886 15.3715 20.9886C13.8139 20.9886 11.8247 20.3483 10.2484 19.482V23.9642C11.9936 24.7176 13.7576 25.0377 15.3715 25.0377C19.2748 25.0377 21.9583 23.0979 21.9583 19.7268C21.9395 14.1146 14.7898 15.1127 14.7898 13.0034Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2001_21339",
    x1: 0,
    y1: 0,
    x2: 10.5105,
    y2: 7.43096,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#392993"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B47B9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2001_21339",
    x1: 1.20502,
    y1: 7.51363,
    x2: 24.4076,
    y2: 26.6525,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#594BB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60A8F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2001_21339",
    x1: 16.0669,
    y1: 28.5189,
    x2: 31.9999,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#61A2EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#58E6FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2001_21339",
    x1: 11.9165,
    y1: 2.27615,
    x2: 32.0002,
    y2: -3.01077e-8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#534EBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6875E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2001_21339",
    x1: 26.2427,
    y1: 18.1422,
    x2: 32,
    y2: 25.0376,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#71A5F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6CC3FA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStripe);
export default __webpack_public_path__ + "static/media/stripe.ed976dc7d3e47af5b2c77edfd9200e52.svg";
export { ForwardRef as ReactComponent };